import React from "react";
import { useNavigate } from "react-router-dom";

const images = [
  {
    src: "/s1.jpg",
    title: "A Window into the Wonders of Different Cultures From arts to cuisine, discover Siam at the Sheikh Zayed Festival.",
    buttonText: "View Full Video",
  },
  { src: "/s2.jpg" },
  { src: "/s3.jpg" },
  { src: "/s4.jpg" },
  { src: "/s5.jpg" },
];

export default function GalleryPage() {
 
    const navigate = useNavigate()
 
    return (
    <div className="py-10 bg-white">
      <h2 className="mb-2 text-3xl font-bold text-center text-[#5C000D]">KNOW MORE</h2>
      <div className="w-20 h-1 mx-auto mb-8 bg-[#FFD367]"></div>
      
      <div className="grid max-w-6xl grid-cols-1 gap-4 px-4 mx-auto md:grid-cols-3">
        <div className="relative md:col-span-2">
          <img
            src={images[0].src}
            alt="Main"
            className="object-cover w-full h-64 md:h-full"
          />
          <div className="absolute bottom-0 left-0 w-full p-4 text-white bg-black bg-opacity-50">
            <p className="text-sm font-semibold md:text-base">{images[0].title}</p>
            <button className="px-4 py-2 mt-2 text-xs text-white bg-gray-700 hover:bg-gray-900 md:text-sm">
              {images[0].buttonText}
            </button>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {images.slice(1).map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={`Gallery ${index + 1}`}
              className="object-cover w-full h-32 md:h-full"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
